import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpApi from 'i18next-http-backend';
// import LanguageDetector from 'i18next-browser-languagedetector';

// Solo usar el detector en desarrollo
const isDev = process.env.NODE_ENV === 'development';

const i18nInstance = i18n
  .use(HttpApi)
  // .use(LanguageDetector) // Deshabilitado para producción
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    lng: isDev ? undefined : 'en', // Forzar inglés en producción
    supportedLngs: ['en', 'es'],
    debug: process.env.NODE_ENV === 'development',
    interpolation: {
      escapeValue: false, // React already escapes
    },
    backend: {
      loadPath: '/locales/{{lng}}/translation.json',
    },
    detection: isDev ? {
      order: ['querystring', 'cookie', 'localStorage', 'navigator', 'htmlTag'],
      caches: ['cookie'],
    } : undefined,
    react: {
      useSuspense: false,
    },
  });

export default i18n; 